import { useEffect, useMemo } from "react"
import { useGetDailyCheckinDetailMutation, useUpdateDailyCheckinMutation } from "store/dailycheckin"
import DailyCheckinForm from "pages/dailycheckin/form/form"
import type { ErrorProps } from "modules/types"
import Notification from "components/notification"
import GLOBAL from "modules/global"

export default function Edit(props: {
  id: number
  isStatusActive: boolean
  open: boolean
  onClose: () => void
}) {
  const [getDailyCheckinDetail, dailyCheckinResult] = useGetDailyCheckinDetailMutation()
  const [update, updateResult] = useUpdateDailyCheckinMutation();
  const { id, open, onClose } = props

  function handleSubmit(formData: FormData) {
    update(formData)
  }

  useEffect(() => {
    if (id && open) {
      getDailyCheckinDetail(id)
    }
  }, [id, open])

  const initialValues = useMemo(() => {
    if (dailyCheckinResult.data) {
      return {
        ...dailyCheckinResult.data,
        rewards: dailyCheckinResult.data.rewards.map(r => ({
          ...r,
          uuid: `${r.day}-${Math.random()}`
        })),
        isStatusActive: props.isStatusActive
      }
    }
  }, [dailyCheckinResult]);

  if (!open) return null

  return (
    <>
      <DailyCheckinForm
        open={open}
        onClose={onClose}
        loading={updateResult.isLoading}
        fetching={dailyCheckinResult.isLoading}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      />
      <Notification
        open={!updateResult.isLoading && !updateResult.isUninitialized}
        onClose={() => (updateResult.isError ? updateResult.reset() : location.reload())}
        isError={Boolean(updateResult.error) && updateResult.isError}
        message={GLOBAL.returnExceptionMessage(updateResult.isError, updateResult.error as ErrorProps)}
      />
    </>
  )
}